module.exports = __webpack_public_path__ + "static/media/wifi-2.4e9d4a61.svg";